export default "__VITE_ASSET__Fqmb$pde__"